import { render, staticRenderFns } from "./BasketSlideOut.vue?vue&type=template&id=64239b4a&"
import script from "./BasketSlideOut.vue?vue&type=script&lang=js&"
export * from "./BasketSlideOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports